export default "__VITE_ASSET__21b2f106__"